<template>
  <AdblockTopbar />
  <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />

    <div class="text__view flex flex-col justify-center text-center">
      <h1 class="font-semibold text-2xl my-5">
        {{ hooks_title_subtitle.title }}
      </h1>
      <p class="leading-6 max-w-5xl mx-auto">
        {{ hooks_title_subtitle.subtitle }}
      </p>
    </div>
    <template v-if="['free'].includes(roleUser)">
      <UpgradePlans :text="' 200+ hooks to grab their attention'" />
      <img class="mt-5" src="../../../src/assets/images/blur-hooks.jpg" />
    </template>
    <template v-else-if="!['free'].includes(roleUser)">
      <div
        class="tips__wrapper flex gap-10 py-10 justify-center justify-items-center lg:py-10"
        v-if="true"
      >
        <div
          @click="selectVisualHook"
          class="cursor-pointer button__tips flex flex-col items-center bg-blue-100 justify-center w-72 h-72 rounded-lg px-8 py-10"
        >
          <h2
            class="leading-6 button__tips-text relative text-md font-semibold text-center text-blue-900"
          >
            Visual Hooks
          </h2>
          <Icon
            viewbox="0 0 90 90"
            fill="text-blue-900"
            name="Window"
            class="w-20 mt-5 mb-5"
          />
          <button
            class="flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
          >
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="rgb(79 70 229)"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
        <div
          @click="selectVerbalHook"
          class="cursor-pointer button__tips flex flex-col items-center justify-center w-72 h-72 rounded-lg px-8 py-10 bg-blue-900"
        >
          <h2
            class="leading-6 button__tips-text relative text-md font-semibold text-center text-white"
          >
            Verbal Hooks
          </h2>
          <Icon
            viewbox="0 0 90 90"
            fill="#fff"
            name="Video"
            class="w-20 mt-5 mb-5"
          />
          <button
            class="flex justify-center w-8 h-8 rounded-full bg-gray-200 p-1 focus:outline-none duration-300 hover:bg-gray-300"
          >
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="rgb(79 70 229)"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </template>

    <template v-else>
      <div v-if="advertisements && advertisements.length">
        <HookInfo />
      </div>
      <div
        class="grid mt-24 p-8 text-center justify-center items-center content-center my-auto"
        v-else
      >
        <div>
          <h2 class="text-4xl font-semibold mb-4">
            Looking for Hooks 👀
          </h2>
          <p class="mb-10 text-lg">
            We recommend you check the completed library and select the awesome
            ads for you
          </p>
          <router-link to="/" class="flex justify-center">
            <Button class="px-12 bg-indigo-600 hover:bg-indigo-500 text-white"
              >Go To Ads Library</Button
            >
          </router-link>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { computed, onBeforeMount } from "vue";
import { useStore } from "vuex";
import Icon from "@/components/UI/Icon";
import HeaderApp from "@/components/Header";
import AdblockTopbar from "@/components/AdblockTopbar";
import UpgradePlans from "@/components/UpgradePlans";
import { useRouter } from "vue-router";

export default {
  components: { HeaderApp, AdblockTopbar, UpgradePlans, Icon },
  setup() {
    onBeforeMount(async () => {
      const status = computed(() => store.state.status);
      if (!status.value) {
            console.log("1")

        router.push("/pricing");
      } else {
        store.commit("SET_HOOKS", 0);
      }
    });
    const store = useStore();
    const router = useRouter();
    const advertisements = computed(() => store.state.hooks);
    const hooks_title_subtitle = computed(() => store.state.hooksTitleSubtitle);

    const selectVisualHook = () => {
      router.push("/visual-hooks");
    };
    const selectVerbalHook = () => {
      router.push("/verbal-hooks");
    };
    const roleUser = computed(() => store.state.role);

    return {
      advertisements,
      roleUser,
      hooks_title_subtitle,
      selectVisualHook,
      selectVerbalHook,
    };
  },
};
</script>

<style scoped>
.library__list {
  @apply grid gap-y-10 gap-x-10;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fit, minmax(19rem, 22rem));
}
.library__item {
  max-width: 24rem;
  min-width: 18rem;
  width: 100%;
}
</style>
